(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/xpert-btn-selector/assets/javascripts/m-system-buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/xpert-btn-selector/assets/javascripts/m-system-buttons.js');
"use strict";

const _React = React,
  useCallback = _React.useCallback;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const analytics = svs.components.analytics;
const selectXpertMsysSpecialValues = svs.components.tipsen.engine.selectors.engineSelectors.selectXpertMsysSpecialValues;
const CollapsibleButtonGroup = svs.components.tipsen.collapsibleGroup.CollapsibleButtonGroup;
const XpertBtnMsys = _ref => {
  let setSize = _ref.setSize,
    size = _ref.size,
    xpertSystems = _ref.xpertSystems,
    _ref$isSizeDisabled = _ref.isSizeDisabled,
    isSizeDisabled = _ref$isSizeDisabled === void 0 ? () => false : _ref$isSizeDisabled;
  const allSpecialValues = useSelector(selectXpertMsysSpecialValues);
  const trackEventOnSetSize = useCallback(selectedSize => {
    analytics.trackEvent({
      category: "Nya tipsen - Fyll i med PIX!",
      action: "\xD6nskat system - ".concat(selectedSize),
      opt_label: location.pathname
    });
  }, []);
  const render = useCallback(v => "".concat(v, " kr"), []);
  return React.createElement(CollapsibleButtonGroup, {
    allValues: xpertSystems,
    clickCallback: trackEventOnSetSize,
    isValueDisabled: isSizeDisabled,
    promotedValues: allSpecialValues,
    render: render,
    setValue: setSize,
    title: "V\xE4lj belopp",
    value: size
  });
};
setGlobal('svs.components.tipsen.xpertenBtnSelector.XpertBtnMsys', XpertBtnMsys);

 })(window);